var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTopo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 239.274,
    height: 46.333,
    viewBox: "0 0 239.274 46.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_63",
    "data-name": "Grupo 63",
    transform: "translate(-837.782 -35.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58",
    "data-name": "Grupo 58",
    transform: "translate(1029.06 35.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_82",
    "data-name": "Caminho 82",
    d: "M1107.312,58.523c-2.051,0-2.543-1.187-1.092-2.638l15.043-15.043c1.451-1.451,2.638-.959,2.638,1.092V54.794a3.741,3.741,0,0,1-3.73,3.73Z",
    transform: "translate(-1101.493 -36.952)",
    fill: "#6ea6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_83",
    "data-name": "Caminho 83",
    d: "M1135.323,41.935c0-2.051,1.187-2.543,2.638-1.092L1153,55.886c1.451,1.451.959,2.638-1.092,2.638h-12.858a3.741,3.741,0,0,1-3.73-3.73Z",
    transform: "translate(-1110.002 -36.952)",
    fill: "#6ea6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_84",
    "data-name": "Caminho 84",
    d: "M1143.06,35.738c-2.052,0-2.543,1.187-1.092,2.637l15.043,15.044c1.451,1.45,2.638.959,2.638-1.093V39.468a3.741,3.741,0,0,0-3.73-3.73Z",
    transform: "translate(-1111.653 -35.738)",
    fill: "#dd6536"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85",
    "data-name": "Caminho 85",
    d: "M1151.911,69.207c2.052,0,2.543,1.187,1.092,2.638l-15.043,15.043c-1.451,1.451-2.638.959-2.638-1.092V72.937a3.741,3.741,0,0,1,3.73-3.73Z",
    transform: "translate(-1110.002 -45.25)",
    fill: "#6ea6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_86",
    "data-name": "Caminho 86",
    d: "M1159.649,75.805c0-2.052-1.187-2.543-2.638-1.093l-15.043,15.044c-1.451,1.45-.959,2.638,1.092,2.638h12.858a3.742,3.742,0,0,0,3.73-3.731Z",
    transform: "translate(-1111.653 -46.578)",
    fill: "#6ea6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_87",
    "data-name": "Caminho 87",
    d: "M1123.9,85.8c0,2.051-1.187,2.543-2.638,1.092L1106.22,71.845c-1.451-1.451-.959-2.638,1.092-2.638h12.858a3.741,3.741,0,0,1,3.73,3.73Z",
    transform: "translate(-1101.493 -45.25)",
    fill: "#6ea6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_88",
    "data-name": "Caminho 88",
    d: "M1116.535,92.393c2.052,0,2.543-1.187,1.093-2.638l-15.043-15.044c-1.45-1.45-2.637-.959-2.637,1.093V88.663a3.742,3.742,0,0,0,3.73,3.731Z",
    transform: "translate(-1099.947 -46.578)",
    fill: "#6ea6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_59",
    "data-name": "Grupo 59",
    transform: "translate(837.782 52.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_89",
    "data-name": "Caminho 89",
    d: "M849.743,65.363H837.782V59.2H859.59L844.966,88.74h-7.038Z",
    transform: "translate(-837.782 -59.2)",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_60",
    "data-name": "Grupo 60",
    transform: "translate(858.165 45.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_90",
    "data-name": "Caminho 90",
    d: "M866.259,75.046a13.708,13.708,0,0,1,14.029-13.767,14.146,14.146,0,0,1,5.622,1.155v7.62a7.236,7.236,0,0,0-5.622-2.575,7.54,7.54,0,1,0,5.622,12.559v7.618a14.147,14.147,0,0,1-5.622,1.157A13.708,13.708,0,0,1,866.259,75.046Z",
    transform: "translate(-866.259 -52.293)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_91",
    "data-name": "Caminho 91",
    d: "M897.381,74.951c0-7.671,5.938-13.82,13.084-13.82a10.9,10.9,0,0,1,8.617,3.626V61.762h6.831V88.245h-6.358l-.157-3.416a10.977,10.977,0,0,1-8.933,3.941C903.318,88.77,897.381,82.675,897.381,74.951Zm21.911,0a7.54,7.54,0,1,0-7.514,7.619A7.49,7.49,0,0,0,919.292,74.951Z",
    transform: "translate(-875.104 -52.251)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_92",
    "data-name": "Caminho 92",
    d: "M945.385,61.8h6.778v2.416a9.979,9.979,0,0,1,7.093-2.942,9.626,9.626,0,0,1,9.511,9.878v17.13h-6.831V72a4.626,4.626,0,0,0-4.782-4.729A4.805,4.805,0,0,0,952.163,72V88.287h-6.778Z",
    transform: "translate(-888.748 -52.293)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_93",
    "data-name": "Caminho 93",
    d: "M985.794,63.754V48.725h6.831v9.511h5.149v5.517h-5.149V84.719h-6.831Z",
    transform: "translate(-900.233 -48.725)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_94",
    "data-name": "Caminho 94",
    d: "M1003.339,75.046a14,14,0,1,1,14.029,13.767A13.708,13.708,0,0,1,1003.339,75.046Zm21.385,0a7.435,7.435,0,0,0-14.87,0,7.435,7.435,0,1,0,14.87,0Z",
    transform: "translate(-905.22 -52.293)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95",
    "data-name": "Caminho 95",
    d: "M1044.516,84.871l3.836-4.677a9.52,9.52,0,0,0,6.358,3.048c2.1,0,3.363-1.1,3.363-2.522,0-1.84-2.154-2.312-5.307-3.416-4.1-1.472-7.567-3.31-7.567-7.934,0-5.359,4.624-8.091,9.721-8.091a12.137,12.137,0,0,1,9.09,3.783l-3.994,4.046a8.064,8.064,0,0,0-5.307-2.575c-1.681,0-2.785.893-2.785,2.26,0,1.786,1.892,2.311,4.993,3.31,3.94,1.313,7.934,3.1,7.934,8.407,0,5.36-4.151,8.3-9.931,8.3A14.905,14.905,0,0,1,1044.516,84.871Z",
    transform: "translate(-916.923 -52.293)",
    fill: "#666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTopo);
export default __webpack_public_path__ + "static/media/logoTopo.f7e07297b455f008c532290f95b7473b.svg";
export { ForwardRef as ReactComponent };